"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnce = void 0;
const react_1 = require("react");
const isFunction_1 = __importDefault(require("lodash/isFunction"));
function useOnce(value) {
    const valueRef = (0, react_1.useRef)();
    const hasCachedValueRef = (0, react_1.useRef)(false);
    if (!hasCachedValueRef.current) {
        if ((0, isFunction_1.default)(value)) {
            valueRef.current = value();
        }
        else {
            valueRef.current = value;
        }
        hasCachedValueRef.current = true;
    }
    return valueRef.current;
}
exports.useOnce = useOnce;
//# sourceMappingURL=utils.js.map